import { PaymentTypes } from "~/operations/messages";

export type PaymentType = keyof typeof PaymentTypes;

export function isPaymentType(type: unknown): type is PaymentType {
  return type !== undefined && typeof type === "string" && type in PaymentTypes;
}
